import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface EventRegistrationRolesSelectorProps {
  roles: string[]
  onChange: (selectedRoles: string[]) => void
  selectedRoles?: string[]
  disabled?: boolean
}

export const EventRegistrationRolesSelector: React.FC<
  EventRegistrationRolesSelectorProps
> = ({ roles, selectedRoles = [], onChange, disabled }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const handleRoleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    let newSelection = []

    newSelection = [...selectedRoles, event.target.name]

    if (!checked) {
      newSelection = selectedRoles.filter(
        (program) => program !== event.target.name
      )
    }

    onChange(newSelection)
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto',
        gridTemplateRows: 'auto auto',
      }}
    >
      <Typography variant="subtitle2" component="p" gutterBottom>
        {t(
          'Events.EventRegistrationRolesSelector.Label',
          'Roles that can Register for this Event:'
        )}
      </Typography>

      {roles.map((role) => {
        return (
          <FormControlLabel
            sx={{
              height: 30,
            }}
            key={`${role}CheckboxLabel`}
            control={
              <Checkbox
                checked={selectedRoles.includes(role)}
                sx={{
                  pl: 2,
                  color: theme.palette.textOrIcon.checkbox,
                  '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                    color: theme.palette.secondary.main,
                  },
                }}
                name={role}
                onChange={handleRoleChange}
                disabled={disabled}
              />
            }
            label={
              <Typography variant="caption" component="p">
                {role}
              </Typography>
            }
          />
        )
      })}
    </Box>
  )
}
